import { React, useState, useEffect, useCallback } from "react";
import { Button, Table, notification } from "antd";
import axiosInstance from "utilities/axios";
import { formatDate } from "utilities/formats";

const RequestTable = ({ search, status, openModal }) => {
  const [content, setContent] = useState([]);
  const [total, setTotal] = useState(0);
  const fetchRequests = useCallback(
    (page, pageSize) => {
      axiosInstance
        .get("/equipment/requests", {
          params: { search, status, page, pageSize },
        })
        .then((response) => {
          setContent(response.data);
          // get total from header
          setTotal(parseInt(response.headers["x-total-count"]));
        })
        .catch((error) => {
          notification.error({
            message: "Error",
            description: error.message,
          });
        });
    },
    [search, status]
  );

  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  const columns = [
    {
      title: "Clinic",
      dataIndex: "clinicNo",
    },
    {
      title: "Request Date",
      dataIndex: "requestDate",
      render: (requestDate) => formatDate(requestDate),
    },
    {
      title: "Request Type",
      dataIndex: "requestType",
    },
    {
      title: "Current Status",
      dataIndex: "currentStatus",
    },
    {
      title: "Brand",
      dataIndex: ["equipment", "brand"],
      width: 150,
    },
    {
      title: "Model",
      dataIndex: ["equipment", "model"],
      width: 150,
    },
    {
      title: "Category",
      dataIndex: ["equipment", "category"],
      width: 150,
    },

    {
      title: "Requestor",
      dataIndex: "requestor",
      width: 200,
      render: (requestor) =>
        `${requestor.firstName} ${requestor.lastName} (${requestor.initials})`,
    },
    {
      title: "Detail",
      dataIndex: "",
      width: 100,
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          onClick={() => {
            openModal(record.id);
          }}
        >
          Detail
        </Button>
      ),
    },
  ];

  return (
    <>
      <Table
        bordered
        pagination={{
          total: total,
          showSizeChanger: true,
          onChange: (page, pageSize) => fetchRequests(page, pageSize),
        }}
        columns={columns}
        size="middle"
        dataSource={content}
        rowKey="id"
      />
    </>
  );
};

export default RequestTable;
